import React from 'react';
import Svg, { Path } from 'react-native-svg';

/**
 * Record camera mark used by the appointments empty state and bottom nav.
 * This is intentionally kept as the Figma artwork rather than the video-call
 * glyph, whose proportions and fill treatment are different.
 */
export default function RecordIcon({ size = 20 }: { size?: number }) {
  return (
    <Svg width={size} height={size} viewBox='0 0 20 20' fill='none'>
      <Path
        d='M5.1411 4.42627H10.3645C12.1899 4.42627 13.3268 5.71529 13.3268 7.53904V12.4606C13.3268 14.2843 12.1899 15.5733 10.3637 15.5733H5.1411C3.31486 15.5733 2.17969 14.2843 2.17969 12.4606V7.53904C2.17969 5.71529 3.32068 4.42627 5.1411 4.42627Z'
        fill='white'
        stroke='#151515'
        strokeWidth={1.84615}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M13.3203 8.45459L15.9407 6.30983C16.3649 5.96221 16.9911 6.02459 17.3387 6.44872C17.4842 6.62668 17.5641 6.84956 17.5632 7.07909L17.5541 12.9262C17.5524 13.4751 17.1075 13.9192 16.5586 13.9175C16.3299 13.9175 16.1079 13.8377 15.9308 13.6921L13.3203 11.5482'
        fill='#151515'
      />
      <Path
        d='M13.3203 8.45459L15.9407 6.30983C16.3649 5.96221 16.9911 6.02459 17.3387 6.44872C17.4842 6.62668 17.5641 6.84956 17.5632 7.07909L17.5541 12.9262C17.5524 13.4751 17.1075 13.9192 16.5586 13.9175C16.3299 13.9175 16.1079 13.8377 15.9308 13.6921L13.3203 11.5482'
        stroke='#151515'
        strokeWidth={1.84615}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.83984 10.0016C5.83984 11.0586 6.69641 11.9143 7.75261 11.9143C8.80954 11.9143 9.66615 11.0586 9.66615 10.0016C9.66615 8.94462 8.80954 8.08887 7.75261 8.08887C6.69641 8.08887 5.83984 8.94462 5.83984 10.0016Z'
        stroke='#151515'
        strokeWidth={1.84615}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Svg>
  );
}
